/**
 * @generated SignedSource<<c27ec949d3a291cc9a9356c54b5c1e61>>
 * @relayHash 0446928955970b59719768048eafdff2
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/362.0.0-2022-04-25T22:46:06.901Z/sourceAttributionMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SourceAttributionInput = {
  guestUserId?: string | null;
  landingPage?: string | null;
  type: string;
  userId: string;
  userToken?: string | null;
  emailToken?: string | null;
  visitCount?: number | null;
  pageVisits?: ReadonlyArray<pageVisits | null> | null;
  clientMutationId?: string | null;
};
export type pageVisits = {
  date?: string | null;
  type?: string | null;
  utmParams?: utmParams | null;
};
export type utmParams = {
  landingPage?: string | null;
  visitCount?: number | null;
};
export type sourceAttributionMutation$variables = {
  input: SourceAttributionInput;
};
export type sourceAttributionMutation$data = {
  readonly sourceAttribution: {
    readonly message: string | null;
  } | null;
};
export type sourceAttributionMutation = {
  variables: sourceAttributionMutation$variables;
  response: sourceAttributionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SourceAttributionPayload",
    "kind": "LinkedField",
    "name": "sourceAttribution",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sourceAttributionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sourceAttributionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ferrum/362.0.0-2022-04-25T22:46:06.901Z/sourceAttributionMutation",
    "metadata": {},
    "name": "sourceAttributionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0776fc099f129d46b7995c62aa8613ee";

export default node;
